const locale = require('./approveEndorsementModal.i18n.json');

/*@ngInject*/
const ApproveEndorsementModalController = function ($rootScope, $scope, $state, coreConstant) {

    $scope.i18n = locale;
    $scope.processingInstructions = '';

    $scope.onConfirm = function () {
        $scope.$close({
            processingInstructions: $scope.processingInstructions
        });
    };

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('gw-um-submission')
    .controller('approveEndorsementModalController', ApproveEndorsementModalController);
